"use strict";

import * as THREE from "three";
import textureMapleFile from "../assets/maple.texture.webp";
import textureSideMapleFile from "../assets/maple.side.texture.webp";
import textureWalnutFile from "../assets/walnut.texture.webp";
import textureSideWalnutFile from "../assets/walnut.side.texture.webp";
import textureCedarFile from "../assets/cedar.texture.webp";
import textureSideCedarFile from "../assets/cedar.side.texture.webp";
import textureOakFile from "../assets/oak.texture.webp";
import textureSideOakFile from "../assets/oak.side.texture.webp";


export var textureMaple, textureWalnut, textureCedar, textureOak,
 textureSideMaple, textureSideWalnut, textureSideOak, textureSideCedar;

export default function didTextureScript() {
  return new Promise(async (resolve) => {
    const tloader = new THREE.TextureLoader();

    textureMaple = await tloader.loadAsync(textureMapleFile);
    textureSideMaple = await tloader.loadAsync(textureSideMapleFile);
    textureWalnut = await tloader.loadAsync(textureWalnutFile);
    textureSideWalnut = await tloader.loadAsync(textureSideWalnutFile);
    textureOak = await tloader.loadAsync(textureOakFile);
    textureSideOak = await tloader.loadAsync(textureSideOakFile);
    textureCedar = await tloader.loadAsync(textureCedarFile);
    textureSideCedar = await tloader.loadAsync(textureSideCedarFile);
    resolve(textureSideCedar);

  });
}
